import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./NavStyles.css";
import { isMobile } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import {
  selectContact,
  selectSimpleMode,
  setNoHeading,
  setOpnContact,
  setSimpleMode,
} from "../../store/globalSlice";
import CustomModal from "../Modal/Modal";
import Contact from "../../container/Contact/Contact";
import { zivotixlogo } from "../../assets/images";

const Navbar = () => {
  const dispatch = useDispatch();
  const [isMenuOpen, setMenuOpen] = useState(true);
  const openContact = useSelector(selectContact);

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(!isMenuOpen);
  };

  const handleHelloClick = () => {
    dispatch(setNoHeading(true));
    dispatch(setOpnContact(true));
  };
  const handleContactClose = () => {
    dispatch(setNoHeading(false));
    dispatch(setOpnContact(false));
  };
  const simpleMode = useSelector(selectSimpleMode);

  return (
    <div
      className="navbar-container"
      style={{ background: simpleMode ? "#001650" : "#121212" }}
    >
      <div className="logo">
        <img src={zivotixlogo} alt="" />
      </div>
      <div className={`nav-links ${isMenuOpen ? "open" : "close"}`}>
        <NavLink
          to="/"
          className="nav-link"
          activeClassName="active"
          onClick={closeMenu}
        >
          Home
        </NavLink>
        <NavLink
          to="/about"
          className="nav-link"
          activeClassName="active"
          onClick={closeMenu}
        >
          About
        </NavLink>
        <NavLink
          to="/services"
          className="nav-link"
          activeClassName="active"
          onClick={closeMenu}
        >
          Services
        </NavLink>
        <NavLink
          to="/portfolio"
          className="nav-link"
          activeClassName="active"
          onClick={closeMenu}
        >
          Portfolio
        </NavLink>
        <NavLink
          to="/contact"
          className="nav-link"
          activeClassName="active"
          onClick={closeMenu}
        >
          Contact
        </NavLink>
      </div>
      {isMobile ? (
        <div
          className="menu-icon"
          onClick={toggleMenu}
          style={{ color: "#fff" }}
        >
          &#9776;
        </div>
      ) : (
        <>
          <span className="say-hello" onClick={handleHelloClick}>
            Say Hello!
          </span>
        </>
      )}
      {openContact && (
        <CustomModal onClose={handleContactClose}>
          <Contact />
        </CustomModal>
      )}
    </div>
  );
};

export default Navbar;

export const ToggleMode = () => {
  const simpleMode = useSelector(selectSimpleMode)
  const dispatch = useDispatch()

  const handleToggle = () => {
    dispatch(setSimpleMode(!simpleMode))
  };

  return (
    <div className="toggle-switch">
      <label className="switch">
        <input type="checkbox" checked={simpleMode} onChange={handleToggle} />
        <span className="slider round"></span>
      </label>
      <div className={simpleMode ? 'active-txt' : 'inactive-txt'}>Simple Mode</div>
    </div>
  );
};

